var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOemCf1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 34C26.2091 34 28 32.2091 28 30C28 27.7909 26.2091 26 24 26C21.7909 26 20 27.7909 20 30C20 32.2091 21.7909 34 24 34Z",
    fill: "#F48000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 46H17.5C16.672 46 16 45.328 16 44.5V41.5C16 38.466 18.466 36 21.5 36H26.5C29.534 36 32 38.466 32 41.5V44.5C32 45.328 31.328 46 30.5 46Z",
    fill: "#F48000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5037 34H33.8438C35.8038 35.9 37.0037 38.56 37.0037 41.5V42H40.5037C41.3238 42 42.0037 41.32 42.0037 40.5V39.5C42.0037 36.46 39.5437 34 36.5037 34Z",
    fill: "#F48000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 34C8.46 34 6 36.46 6 39.5V40.5C6 41.32 6.68 42 7.5 42H11V41.5C11 38.56 12.2 35.9 14.16 34H11.5Z",
    fill: "#F48000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 32C16.2091 32 18 30.2091 18 28C18 25.7909 16.2091 24 14 24C11.7909 24 10 25.7909 10 28C10 30.2091 11.7909 32 14 32Z",
    fill: "#F48000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 32C36.2091 32 38 30.2091 38 28C38 25.7909 36.2091 24 34 24C31.7909 24 30 25.7909 30 28C30 30.2091 31.7909 32 34 32Z",
    fill: "#F48000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.102 32.554C5.608 32.092 6.152 31.672 6.746 31.324C6.278 30.308 6 29.19 6 28C6 23.588 9.588 20 14 20C16.512 20 18.73 21.188 20.198 23.006C21.334 22.384 22.616 22 24 22C25.384 22 26.666 22.384 27.802 23.006C29.27 21.188 31.488 20 34 20C38.412 20 42 23.588 42 28C42 29.19 41.722 30.308 41.254 31.324C41.636 31.548 41.998 31.8 42.344 32.072C45.74 29.912 48 26.148 48 21.866C48 15.734 43.386 10.616 37.346 9.854C34.722 5.056 29.578 2 24 2C16.91 2 10.76 6.93 9.206 13.658C4.038 14.202 0 18.542 0 23.8C0 27.538 2.064 30.778 5.102 32.554Z",
    fill: "#F48000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOemCf1);
export default __webpack_public_path__ + "static/media/oem_cf1.1ccf701a16a1310ad92e1d73899a34ae.svg";
export { ForwardRef as ReactComponent };